import { useEffect, useRef, useState } from 'react';

export function useDebouncedBigInt<T extends bigint | undefined>(
  value: T,
  isUpdating: boolean
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const previousValueRef = useRef<T>(value);
  const isUpdatingRef = useRef(false);

  useEffect(() => {
    if (isUpdating || isUpdatingRef.current) {
      return;
    }

    // Only update if value actually changed
    if (previousValueRef.current !== value) {
      previousValueRef.current = value;
      isUpdatingRef.current = true;

      // Update after current render cycle completes
      setDebouncedValue(value);

      // Reset flag after state update
      isUpdatingRef.current = false;
    }
  }, [value, isUpdating]);

  return debouncedValue;
}
